var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import sortableByPosition from 'ilios-common/utils/sortable-by-position';
import { TrackedAsyncData } from 'ember-async-data';
import { cached } from '@glimmer/tracking';
import { map } from 'rsvp';
import { DateTime } from 'luxon';
import { sortBy, uniqueValues } from 'ilios-common/utils/array-helpers';
let Course = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('date'), _dec5 = attr('date'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = belongsTo('course-clerkship-type', {
  async: true,
  inverse: 'courses'
}), _dec12 = belongsTo('school', {
  async: true,
  inverse: 'courses'
}), _dec13 = hasMany('user', {
  async: true,
  inverse: 'directedCourses'
}), _dec14 = hasMany('user', {
  async: true,
  inverse: 'administeredCourses'
}), _dec15 = hasMany('user', {
  async: true,
  inverse: 'studentAdvisedCourses'
}), _dec16 = hasMany('cohort', {
  async: true,
  inverse: 'courses'
}), _dec17 = hasMany('course-objective', {
  async: true,
  inverse: 'course'
}), _dec18 = hasMany('mesh-descriptor', {
  async: true,
  inverse: 'courses'
}), _dec19 = hasMany('course-learning-material', {
  async: true,
  inverse: 'course'
}), _dec20 = hasMany('session', {
  async: true,
  inverse: 'course'
}), _dec21 = belongsTo('course', {
  inverse: 'descendants',
  async: true
}), _dec22 = hasMany('course', {
  inverse: 'ancestor',
  async: true
}), _dec23 = hasMany('term', {
  async: true,
  inverse: 'courses'
}), _class = class Course extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "level", _descriptor2, this);
    _initializerDefineProperty(this, "year", _descriptor3, this);
    _initializerDefineProperty(this, "startDate", _descriptor4, this);
    _initializerDefineProperty(this, "endDate", _descriptor5, this);
    _initializerDefineProperty(this, "externalId", _descriptor6, this);
    _initializerDefineProperty(this, "locked", _descriptor7, this);
    _initializerDefineProperty(this, "archived", _descriptor8, this);
    _initializerDefineProperty(this, "publishedAsTbd", _descriptor9, this);
    _initializerDefineProperty(this, "published", _descriptor10, this);
    _initializerDefineProperty(this, "clerkshipType", _descriptor11, this);
    _initializerDefineProperty(this, "school", _descriptor12, this);
    _initializerDefineProperty(this, "directors", _descriptor13, this);
    _initializerDefineProperty(this, "administrators", _descriptor14, this);
    _initializerDefineProperty(this, "studentAdvisors", _descriptor15, this);
    _initializerDefineProperty(this, "cohorts", _descriptor16, this);
    _initializerDefineProperty(this, "courseObjectives", _descriptor17, this);
    _initializerDefineProperty(this, "meshDescriptors", _descriptor18, this);
    _initializerDefineProperty(this, "learningMaterials", _descriptor19, this);
    _initializerDefineProperty(this, "sessions", _descriptor20, this);
    _initializerDefineProperty(this, "ancestor", _descriptor21, this);
    _initializerDefineProperty(this, "descendants", _descriptor22, this);
    _initializerDefineProperty(this, "terms", _descriptor23, this);
  }
  get _schoolData() {
    return new TrackedAsyncData(this.school);
  }
  get _cohortsData() {
    return new TrackedAsyncData(this.cohorts);
  }
  get _courseObjectivesData() {
    return new TrackedAsyncData(this.courseObjectives);
  }
  get _sessionsData() {
    return new TrackedAsyncData(this.sessions);
  }
  get _termsData() {
    return new TrackedAsyncData(this.terms);
  }
  get _publishedSessionOfferings() {
    if (!this._sessionsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._sessionsData.value.filter(s => s.isPublished).map(s => s.offerings)));
  }
  get publishedOfferingCount() {
    if (!this._publishedSessionOfferings?.isResolved) {
      return 0;
    }
    return uniqueValues(this._publishedSessionOfferings.value.flat()).length;
  }
  get allTreeCompetencies() {
    if (!this._courseObjectivesData.isResolved) {
      return null;
    }
    return this._courseObjectivesData.value.map(co => co.treeCompetencies);
  }
  get competencies() {
    if (!this._courseObjectivesData.isResolved) {
      return [];
    }
    const treeCompetencies = this._courseObjectivesData.value.map(o => o.treeCompetencies);
    return uniqueValues(treeCompetencies.flat()).filter(Boolean);
  }
  get _competencyDomains() {
    return new TrackedAsyncData(Promise.all(this.competencies?.map(c => c.getDomain())));
  }
  get _unsortedDomainsWithSubcompetencies() {
    if (!this._competencyDomains.isResolved || this.competencies === null) {
      return null;
    }
    return new TrackedAsyncData(map(uniqueValues(this._competencyDomains.value), async domain => {
      let subCompetencies = (await domain.children).filter(competency => {
        return this.competencies.includes(competency);
      });
      subCompetencies = sortBy(subCompetencies, 'title');
      return {
        title: domain.title,
        id: domain.id,
        subCompetencies
      };
    }));
  }
  get domainsWithSubcompetencies() {
    if (!this._unsortedDomainsWithSubcompetencies || !this._unsortedDomainsWithSubcompetencies.isResolved) {
      return [];
    }
    return sortBy(this._unsortedDomainsWithSubcompetencies.value, 'title');
  }
  get requiredPublicationIssues() {
    const issues = [];
    if (!this.startDate) {
      issues.push('startDate');
    }
    if (!this.endDate) {
      issues.push('endDate');
    }
    if (!this.cohorts.length) {
      issues.push('cohorts');
    }
    return issues;
  }
  get optionalPublicationIssues() {
    const issues = [];
    if (!this.terms.length) {
      issues.push('terms');
    }
    if (!this.courseObjectives.length) {
      issues.push('courseObjectives');
    }
    if (!this.meshDescriptors.length) {
      issues.push('meshDescriptors');
    }
    return issues;
  }
  get _programSchoolsData() {
    if (!this._cohortsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(map(this._cohortsData.value, async cohort => {
      const programYear = await cohort.programYear;
      const program = await programYear.program;
      return program.school;
    }));
  }
  get schools() {
    if (!this._programSchoolsData?.isResolved || !this._schoolData.isResolved) {
      return [];
    }
    return uniqueValues([...this._programSchoolsData.value, this._schoolData.value]);
  }
  get _schoolVocabulariesData() {
    return new TrackedAsyncData(Promise.all(this.schools.map(s => s.vocabularies)));
  }
  get assignableVocabularies() {
    if (!this._schoolVocabulariesData?.isResolved) {
      return [];
    }
    return sortBy(this._schoolVocabulariesData.value.flat(), ['school.title', 'title']);
  }

  /**
   * A list of course objectives, sorted by position (asc) and then id (desc).
   */
  get sortedCourseObjectives() {
    if (!this._courseObjectivesData.isResolved) {
      return null;
    }
    return this._courseObjectivesData.value.slice().sort(sortableByPosition);
  }
  get hasMultipleCohorts() {
    return this.cohorts.length > 1;
  }
  get _termVocabularies() {
    if (!this._termsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._termsData.value.map(t => t.vocabulary)));
  }
  /**
   * A list of all vocabularies that are associated via terms.
   */
  get associatedVocabularies() {
    if (!this._termVocabularies?.isResolved) {
      return [];
    }
    return sortBy(uniqueValues(this._termVocabularies.value), 'title');
  }
  get termCount() {
    return this.hasMany('terms').ids().length;
  }
  setDatesBasedOnYear() {
    const today = DateTime.now();
    const firstDayOfYear = DateTime.fromObject({
      year: this.year,
      month: 7,
      day: 1
    });
    const startDate = today < firstDayOfYear ? firstDayOfYear : today;
    const endDate = startDate.plus({
      weeks: 8
    });
    this.startDate = startDate.toJSDate();
    this.endDate = endDate.toJSDate();
  }
  get xObjectives() {
    return this.courseObjectives;
  }
  get isPublished() {
    return this.published;
  }
  get isNotPublished() {
    return !this.isPublished;
  }
  get isScheduled() {
    return this.publishedAsTbd;
  }
  get isPublishedOrScheduled() {
    return this.publishedAsTbd || this.isPublished;
  }
  get allPublicationIssuesLength() {
    return this.requiredPublicationIssues.length + this.optionalPublicationIssues.length;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "year", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "startDate", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "endDate", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "externalId", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "locked", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "archived", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "publishedAsTbd", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "published", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "clerkshipType", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "school", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_schoolData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_schoolData"), _class.prototype), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "directors", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "administrators", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "studentAdvisors", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "cohorts", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_cohortsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_cohortsData"), _class.prototype), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "courseObjectives", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_courseObjectivesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_courseObjectivesData"), _class.prototype), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "meshDescriptors", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "learningMaterials", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "sessions", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_sessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_sessionsData"), _class.prototype), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "ancestor", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "descendants", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "terms", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_termsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_termsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_publishedSessionOfferings", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_publishedSessionOfferings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "publishedOfferingCount", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "publishedOfferingCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_competencyDomains", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_competencyDomains"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_unsortedDomainsWithSubcompetencies", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_unsortedDomainsWithSubcompetencies"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_programSchoolsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_programSchoolsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_schoolVocabulariesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_schoolVocabulariesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_termVocabularies", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_termVocabularies"), _class.prototype), _class);
export { Course as default };